import React from "react";
import { useApp } from "@/context/AppContext";
import { Languages } from "lucide-react";

/** English ⇄ Arabic switch for the public pages, which have no account settings to reach. */
export const PublicLangToggle = ({ onDark = true }) => {
  const { lang, setLang, t } = useApp();
  const next = lang === "ar" ? "en" : "ar";
  return (
    <button onClick={() => setLang(next)} data-testid="public-language-toggle"
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors ${
        onDark ? "border-white/25 text-white/75 hover:text-white hover:bg-white/10"
               : "border-border text-muted-foreground hover:text-foreground"}`}>
      <Languages className="h-3.5 w-3.5" />
      {next === "ar" ? t("lang_toggle_ar") : t("lang_toggle_en")}
    </button>
  );
};
